import React, { Component } from 'react';

export default class OrderComplete extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            time : 5
        }
    }
    componentDidMount()
    {
        setTimeout(this.timeSet.bind(this), 1000);
    }
    timeSet()
    {
        let time = this.state.time;
        time = time - 1;
        if( time < 0 ){
            let backUrl = sessionStorage.getItem("backurl");
            if(!backUrl) {
                window.location.href = "http://www.tfamily.co.kr/";//https://tworld.co.kr/";
            } else {
                window.location.href = backUrl;
            }            
        } else {
            this.setState({
                time: time
            });
            setTimeout(this.timeSet.bind(this), 1000);
        }
    }
    render()
    {
        const self = this;
        return (
            <div className="centralize-wrapper">
                <div className="centralize-inner">
                    <div className="container">
                        <div className="row text-center">
                            <img src={'/img/complete.png'} />
                            <div className="pt15 font14">
                                <b><span>{self.state.time}</span>초 후 신청 페이지로 이동합니다.</b>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
